/**
 * Traces API
 * Proxy endpoints for Opik trace/span data
 */

import apiClient from './client';
import type {
  TracePublic,
  TraceListParams,
  TraceListResponse,
  SpanListResponse,
  TraceStatsResponse,
  TraceMetricsParams,
  TraceMetricsResponse,
  TracesStatus,
} from '@/types/traces';

export const tracesApi = {
  getStatus: async (): Promise<TracesStatus> => {
    const response = await apiClient.get('/traces/status');
    return response.data;
  },

  list: async (params: TraceListParams = {}): Promise<TraceListResponse> => {
    const response = await apiClient.get('/traces', { params });
    return response.data;
  },

  get: async (traceId: string): Promise<TracePublic> => {
    const response = await apiClient.get(`/traces/${traceId}`);
    return response.data;
  },

  getSpans: async (
    traceId: string,
    params: { page?: number; size?: number; span_type?: string } = {}
  ): Promise<SpanListResponse> => {
    const response = await apiClient.get(`/traces/${traceId}/spans`, { params });
    return response.data;
  },

  getStats: async (projectName?: string): Promise<TraceStatsResponse> => {
    const response = await apiClient.get('/traces/stats', {
      params: projectName ? { project_name: projectName } : undefined,
    });
    return response.data;
  },

  getMetrics: async (params: TraceMetricsParams = {}): Promise<TraceMetricsResponse> => {
    const response = await apiClient.get('/traces/metrics', { params });
    return response.data;
  },
};
